import { useTranslation } from 'react-i18next';
import type { PipelineStatus } from '../../../types/api.js';

export interface PipelineStatusBadgeProps {
  /** パイプラインステータス */
  status: PipelineStatus;
}

/** @graph-connects none */
const statusStyles: Record<PipelineStatus, string> = {
  ACTIVE:
    'bg-[var(--color-success-muted)] text-[var(--color-success)] border-[var(--color-success)]/20',
  DISABLED:
    'bg-[var(--color-bg-elevated)] text-[var(--color-text-muted)] border-[var(--color-border)]',
};

/**
 * @graph-stack cortex-admin
 * @graph-domain Infrastructure
 * @graph-business パイプラインステータスバッジ。ACTIVE=緑、DISABLED=グレーで状態を色分け表示
 * @graph-connects none
 */
export function PipelineStatusBadge({ status }: PipelineStatusBadgeProps) {
  const { t } = useTranslation();

  const label = status === 'ACTIVE' ? t('pipeline.active') : t('pipeline.disabled');

  return (
    <span
      className={`
        inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border
        ${statusStyles[status]}
      `}
    >
      {status === 'ACTIVE' && (
        <span className="w-1.5 h-1.5 rounded-full bg-[var(--color-success)] mr-1.5" />
      )}
      {label}
    </span>
  );
}
